export const BRANCH_RELEASE = true;
export const VERSION = "V.4.0.0";
export const DOMAIN = BRANCH_RELEASE
  ? `https://tmp.shipzo.com`
  : `http://localhost:3000`;
export const BASE_URL = BRANCH_RELEASE
  ? `https://tmp.shipzo.com`
  : `http://192.168.1.237`;
export const API_URL = `${BASE_URL}/api-shipzo-web/public`;
